import Wrap from './styles';

import Animation from 'services/utils/Animation';

import Navigation from '../../../../../Navigation';

/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 * 
 * useRef permite que persista valores entre renderizações, ele pode
 * ser usado para armazenar um valor mutável que não causa uma nova
 * renderização quando atualizado e pode ser usado para acessar di-
 * retamente um elemento do DOM.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useState, useCallback, useRef, useEffect } from 'react';
import Mobile from 'views/MapView/components/Mobile';

/**
 * LayerActionsMobile
 * 
 * @param {array} views  
 * @param {number} initialView
 * @param {*} props
 * @returns 
 */
const LayerActionsMobile = ({ views = [], initialView = 0, ...props }) => {
  const [activeView, setActiveView] = useState(initialView);
  const flex = useRef();

  const moveTo = useCallback(
    (index) => (e) => {
      setActiveView(index);
    },
    [setActiveView]
  );

  /**
   * Ação de animação até o step ativo activeView
   */
  const scrollStep = useCallback(() => {
    if (flex.current) {
      let scrollLeft = flex.current.scrollLeft;
      let width = flex.current.offsetWidth;
      const animation = new Animation(
        500,
        (stepNumber) => {
          flex.current.scrollLeft =
            scrollLeft * (1 - stepNumber) + activeView * width * stepNumber;
        },
        () => {
          flex.current.scrollLeft = activeView * width;
        }
      );
      animation.start();
    }
  }, [activeView, flex]);

  // Escuta as alterações em activeView para fazer andar as tabs
  useEffect(() => {
    if (typeof activeView !== 'undefined') {
      scrollStep();
    }
  }, [activeView, scrollStep]);

  return (
    <Wrap>
      <header>
        <Mobile>
          <Navigation views={views} activeView={activeView} moveTo={moveTo} />
        </Mobile>
      </header>
      <div className="scrollable" ref={flex}>
        {views.map(({ Component, props }, i) => (
          <div className="scrollable-content" key={i}>
            <Component {...props} activeView={activeView === i} />
          </div>
        ))}
      </div>
    </Wrap>
  );
};

export default LayerActionsMobile;
